import styled from 'styled-components';
import { appConfig } from '../../../../configureApp';
const Button = styled.button`
  margin: 8px 0;
  border: 1px solid ${(props) => (props.borderColor) ? props.borderColor : '#0d6efd'};
  line-height: 100%;
  border-radius: ${(props) => (props.borderRadius) ? props.borderRadius : appConfig.reactAppEnv === 'scti' ? '100px' : "4px"};
  font-size:${(props) => (props.fontSize) ? props.fontSize : '0.87em'};
  background-color: ${(props) => (props.backgroundColor) ? props.backgroundColor : appConfig.reactAppEnv === 'scti'  || appConfig.reactAppEnv === 'tugo' ? '#008BCE' : "#0d6efd"};
  color: ${(props) => (props.color) ? props.color : '#fbfdfe'};
  padding: ${(props) => (props.padding) ? props.padding : '0.5em 1.25em'};
  min-width: 100px;
  cursor: pointer;
  fontSize: 16px;
  font-family: ${(props) => (props.fontFamily) ? props.fontFamily : appConfig.reactAppEnv === 'scti' ? 'Omnes' : "Roboto"};
  &:hover {
    background-color:  ${(props) => (props.hoverBackgroundColor) ? props.hoverBackgroundColor : '#0d61fd'};
  }
  &:disabled {
      background-color: #AAC9BF;
      border-color: #AAC9BF;
    cursor: not-allowed;
    &:hover {
      background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#AAC9BF'};
    }
  }
  @media screen and (max-width: 576px) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
  }
  &:focus {
    outline: none;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Button/Button.js